<template>
  <div class="body_about">
    <div class="about-me-top">
      <div class="me-top-top">
        <img src="https://img.aixuejie.cn/extra/showclub/5_1603682434/5_爱学界_1603682439_ee1eaddfe346bebfead92d86e04147cb.png">
      </div>
      <div class="me-top-bottom">
        <img src="@/assets/image/axj_web/axj_web_body_icon.png">
      </div>
    </div>
    <div class="about-me-bottom">
      <div class="me-bottom-item">
        <div class="item-title">
          <span>产品与服务</span>
        </div>
        <div class="item-body">
          <p>爱学界App是一个服务于产学研机构主体和个人主体的生态系统，核心功能包括但不限于：为高校、研究院所、企业等机构提供信息精准发布与收集服务；为个人提供精准信息推送、信息发布和社交服务；针对高校，为年级、班级、课题组等集体或团队提供轻量管理工具；为高校师生提供学习、工作、娱乐、健康等服务。</p>
          <p>
            湖南爱学界信息科技有限公司，是爱学界APP的唯一研发和运营方。
          </p>
        </div>
      </div>
      <div class="me-bottom-item">
        <div class="item-title">
          <span>公司与团队</span>
        </div>
        <div class="item-body">
          <p >公司创始人，周东明先生，1995至2006年在国防科技大学学习，2007至2020年在国防科技大学工作，2020年转业创立湖南爱学界信息科技有限公司；
            公司联合创始人，张博汉先生，2007至2011年在国防科技大学学习，2011至2020年在空军部队工作，2020年转业加入爱学界。
          </p>
          <p >公司技术与运营团队：一群无所畏惧的少年。</p>
            <p>公司愿景：为产学研各主体提供全方位服务，促进产学研深度融合发展。</p>
        </div>
      </div>
      <div class="me-bottom-item">
        <div class="item-title">
          <span>联系我们</span>
        </div>
        <div class="item-body">
          <p class="do-not">
          【联系邮箱】
          </p>
          <p class="do-not">
          产品部门：bh_axj@163.com
          </p>
          <p class="do-not">
          技术部门：py_axj@163.com
          </p>
          <p class="do-not">
          【公司地址】
          </p>
          <p class="do-not">
          湖南省长沙市长沙中电软件园5栋4层403-23
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "body_about"
}
</script>

<style slot-scope lang="scss">
.body_about{
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 37.99px;
  .about-me-top{
    display: flex;
    flex-flow: column;
    align-items: center;
      .me-top-top{
        img{
          width: 121.5px;
          height: 116px;
        }
      }
      .me-top-bottom{
        img{
          width: 106.5px;
          height: 26.3px;
        }
        margin-top: 26.25px;
      }
    }
    .about-me-bottom{
      margin-top: 39px;
      margin-left: 95px;
      align-items: center;
      display: flex;
      .me-bottom-item{
        opacity: 0.4;
        background: #02031B;
        border-radius: 4px;
        width: 293.25px;
        height: 335.33px;
        display: flex;
        flex-flow: column;
        margin-right: 85.5px;
        align-items: center;
        .item-title{
          width: 74px;
          flex: 1;
          display: flex;
          align-items: center;
          //margin-top: 45.75px;
          span{
            font-family: Source Han Sans CN;
            font-style: normal;
            font-weight: normal;
            font-size: 13.5px;
            line-height: 26px;
            /* identical to box height */
            color: #F4F4F4;
          }
        }
        .item-body{
          flex: 5;
          width: 245.25px;
          //height: 144.65px;
          //margin-top: 27px;
          p:not(.do-not){
            text-indent: 2em;
            /* or 22px */
          }
          p{
            color: #FFFFFF;
            font-family: Source Han Sans CN;
            font-style: normal;
            font-weight: normal;
            font-size: 9.75px;
            letter-spacing: 0.045em;
          }
        }
      }
      .me-bottom-item:hover{
        opacity: 1;
        cursor: pointer;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_body/component/body_about/index.vue